module.exports = __webpack_public_path__ + "static/hourglass-404acefa0ed1e9d17b38ff31084220ba.webm";